<div class="wrapper">
  @if (userApplication(); as userApplication) {
    <div>
      <div class="header">
        <h2>Please sign up for Encompass</h2>
      </div>
      <input class="standardTextBox" [readonly]="applicationData()" [(ngModel)]="userApplication.workEmail"
        placeholder="Work Email"/>
      <button matButton="elevated"
        [disabled]="!userApplication.workEmail || userApplication.workEmail.length < 5 || applicationData()"
        (click)="getApplicationData()">
        <span>
          <mat-icon class="size-16">play_circle_filled</mat-icon>
          <label>Start Application</label>
        </span>
      </button>
      @if (applicationData()) {
        <div class="applicationData">
          <form #applicationForm="ngForm">
            <div class="inputRow">
              <span class="inputLabel">
                <label>First Name</label>
              </span>
              <span class="inputField">
                <input name="firstNameInput" class="standardTextBox" [ngClass]="{'inputError': firstNameInput.invalid}"
                  required [(ngModel)]="userApplication.firstName" #firstNameInput="ngModel"/>
              </span>
            </div>
            <div class="inputRow">
              <span class="inputLabel">
                <label>Last Name</label>
              </span>
              <span class="inputField">
                <input name="lastNameInput" class="standardTextBox" [ngClass]="{'inputError': lastNameInput.invalid}"
                  required [(ngModel)]="userApplication.lastName" #lastNameInput="ngModel"/>
              </span>
            </div>
            <div class="inputRow">
              <span class="inputLabel">
                <label>Job Title</label>
              </span>
              <span class="inputField">
                <select (change)="jobTitleChanged()" class="selectionInput" [(ngModel)]="userApplication.jobTitle"
                  name="jobTitleInput">
                  @for (title of applicationData().jobTitles; track title) {
                    <option [value]="title.code">{{ title.description }}
                    </option>
                  }
                </select>
              </span>
            </div>
            <div class="inputRow">
              <span class="inputLabel">
                <label>Company</label>
              </span>
              @if (!isInternalOrgUnitID(this.applicationData().orgUnitId)) {
                <span class="inputField">
                  <select class="selectionInput" [disabled]="userApplication.jobTitle === 'default'"
                    [(ngModel)]="userApplication.orgName" name="companyInput">
                    @for (company of applicationData().companies; track company) {
                      <option [value]="company.code">{{ company.description }}
                      </option>
                    }
                  </select>
                </span>
              }
              @if (isInternalOrgUnitID(this.applicationData().orgUnitId)) {
                <span class="inputField">
                  <label>{{this.applicationData().orgUnitId}}</label>
                </span>
              }
            </div>
            <div class="inputRow">
              <span class="inputLabel">
                <label>Phone</label>
              </span>
              <span class="inputField">
                <input name="phoneInput" class="standardTextBox" [ngClass]="{'inputError': phoneInput.invalid}" required
                  [(ngModel)]="userApplication.phoneNumber" #phoneInput="ngModel"/>
              </span>
            </div>
            <div class="toolbar">
              <button matButton="text" [disabled]="isBusy()" (click)="startOver()">
                <span>
                  <mat-icon class="size-16">replay</mat-icon>
                  <label>Start Over</label>
                </span>
              </button>
              <span class="spacer"></span>
              <button matButton="text" [disabled]="applicationForm.invalid || submitDisabled()" (click)="submitApplication()">
                <span>
                  <mat-icon class="size-16">done</mat-icon>
                  <label>Submit</label>
                </span>
              </button>
            </div>
          </form>
        </div>
      }
    </div>
  }
  @if (applicationExists()) {
    <div>
      <div class="header">
        <h2>Your application has been received and is being processed</h2>
      </div>
    </div>
  }
  @if (errorMessage()) {
    <div class="errorMessage">
      <pre>{{ errorMessage() }}</pre>
    </div>
  }
</div>
@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  </div>
}
